module.exports = "/assets/Inter-Light.3ee890bd.woff";